import { render, staticRenderFns } from "./NavBreadcrumb.vue?vue&type=template&id=458e03ca&"
import script from "./NavBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./NavBreadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports